import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <form id="login-form" method="post">
  <div id="credentials" class={{this.credentialsClass}}>
    <div class="input-group" {{did-insert this.passkeyConditionalLogin}}>
      <Input
        @value={{@loginName}}
        @type="email"
        id="login-account-name"
        class={{value-entered @loginName}}
        autocomplete={{if @canUsePasskeys "username webauthn" "username"}}
        autocorrect="off"
        autocapitalize="off"
        disabled={{@showSecondFactor}}
        autofocus="autofocus"
        tabindex="1"
        {{on "input" @loginNameChanged}}
        {{on "keydown" this.loginOnEnter}}
      />
      <label class="alt-placeholder" for="login-account-name">
        {{i18n "login.email_placeholder"}}
      </label>
      {{#if @canLoginLocalWithEmail}}
        <a
          href
          class={{if @loginName "" "no-login-filled"}}
          tabindex="3"
          id="email-login-link"
          {{on "click" this.emailLogin}}
        >
          {{i18n "email_login.login_link"}}
        </a>
      {{/if}}
    </div>
    <div class="input-group">
      <PasswordField
        {{on "keydown" this.loginOnEnter}}
        @value={{@loginPassword}}
        @capsLockOn={{this.capsLockOn}}
        type={{if this.maskPassword "password" "text"}}
        disabled={{this.disableLoginFields}}
        autocomplete="current-password"
        maxlength="200"
        tabindex="1"
        id="login-account-password"
        class={{value-entered @loginPassword}}
      />
      <label class="alt-placeholder" for="login-account-password">
        {{i18n "login.password"}}
      </label>
      <div class="login__password-links">
        <a
          href
          id="forgot-password-link"
          tabindex="3"
          {{on "click" this.handleForgotPassword}}
        >
          {{i18n "forgot_password.action"}}
        </a>
        {{#if @loginPassword}}
          <TogglePasswordMask
            @maskPassword={{this.maskPassword}}
            @togglePasswordMask={{this.togglePasswordMask}}
            tabindex="3"
          />
        {{/if}}
      </div>
      <div class="caps-lock-warning {{unless this.capsLockOn 'hidden'}}">
        {{d-icon "exclamation-triangle"}}
        {{i18n "login.caps_lock_warning"}}</div>
    </div>
  </div>
  <SecondFactorForm
    @secondFactorMethod={{@secondFactorMethod}}
    @secondFactorToken={{@secondFactorToken}}
    @backupEnabled={{@backupEnabled}}
    @isLogin={{true}}
    class={{this.secondFactorClass}}
  >
    {{#if @showSecurityKey}}
      <SecurityKeyForm
        @allowedCredentialIds={{@securityKeyAllowedCredentialIds}}
        @challenge={{@securityKeyChallenge}}
        @showSecurityKey={{@showSecurityKey}}
        @showSecondFactor={{@showSecondFactor}}
        @secondFactorMethod={{@secondFactorMethod}}
        @otherMethodAllowed={{@otherMethodAllowed}}
        @action={{this.authenticateSecurityKey}}
      />
    {{else}}
      <SecondFactorInput
        {{on "keydown" this.loginOnEnter}}
        {{on "input" (with-event-value (fn (mut @secondFactorToken)))}}
        @secondFactorMethod={{@secondFactorMethod}}
        value={{@secondFactorToken}}
        id="login-second-factor"
      />
    {{/if}}
  </SecondFactorForm>
</form>
*/
{
  "id": "14gurTdk",
  "block": "[[[10,\"form\"],[14,1,\"login-form\"],[14,\"method\",\"post\"],[12],[1,\"\\n  \"],[10,0],[14,1,\"credentials\"],[15,0,[30,0,[\"credentialsClass\"]]],[12],[1,\"\\n    \"],[11,0],[24,0,\"input-group\"],[4,[38,0],[[30,0,[\"passkeyConditionalLogin\"]]],null],[12],[1,\"\\n      \"],[8,[39,1],[[24,1,\"login-account-name\"],[16,0,[28,[37,2],[[30,1]],null]],[16,\"autocomplete\",[52,[30,2],\"username webauthn\",\"username\"]],[24,\"autocorrect\",\"off\"],[24,\"autocapitalize\",\"off\"],[16,\"disabled\",[30,3]],[24,\"autofocus\",\"autofocus\"],[24,\"tabindex\",\"1\"],[4,[38,4],[\"input\",[30,4]],null],[4,[38,4],[\"keydown\",[30,0,[\"loginOnEnter\"]]],null]],[[\"@value\",\"@type\"],[[30,1],\"email\"]],null],[1,\"\\n      \"],[10,\"label\"],[14,0,\"alt-placeholder\"],[14,\"for\",\"login-account-name\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"login.email_placeholder\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,5],[[[1,\"        \"],[11,3],[24,6,\"\"],[16,0,[52,[30,1],\"\",\"no-login-filled\"]],[24,\"tabindex\",\"3\"],[24,1,\"email-login-link\"],[4,[38,4],[\"click\",[30,0,[\"emailLogin\"]]],null],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"email_login.login_link\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"input-group\"],[12],[1,\"\\n      \"],[8,[39,6],[[16,\"disabled\",[30,0,[\"disableLoginFields\"]]],[24,\"autocomplete\",\"current-password\"],[24,\"maxlength\",\"200\"],[24,\"tabindex\",\"1\"],[24,1,\"login-account-password\"],[16,0,[28,[37,2],[[30,6]],null]],[16,4,[52,[30,0,[\"maskPassword\"]],\"password\",\"text\"]],[4,[38,4],[\"keydown\",[30,0,[\"loginOnEnter\"]]],null]],[[\"@value\",\"@capsLockOn\"],[[30,6],[30,0,[\"capsLockOn\"]]]],null],[1,\"\\n      \"],[10,\"label\"],[14,0,\"alt-placeholder\"],[14,\"for\",\"login-account-password\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"login.password\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"login__password-links\"],[12],[1,\"\\n        \"],[11,3],[24,6,\"\"],[24,1,\"forgot-password-link\"],[24,\"tabindex\",\"3\"],[4,[38,4],[\"click\",[30,0,[\"handleForgotPassword\"]]],null],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"forgot_password.action\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,6],[[[1,\"          \"],[8,[39,7],[[24,\"tabindex\",\"3\"]],[[\"@maskPassword\",\"@togglePasswordMask\"],[[30,0,[\"maskPassword\"]],[30,0,[\"togglePasswordMask\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n      \"],[10,0],[15,0,[29,[\"caps-lock-warning \",[52,[51,[30,0,[\"capsLockOn\"]]],\"hidden\"]]]],[12],[1,\"\\n        \"],[1,[28,[35,9],[\"exclamation-triangle\"],null]],[1,\"\\n        \"],[1,[28,[35,5],[\"login.caps_lock_warning\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,10],[[16,0,[30,0,[\"secondFactorClass\"]]]],[[\"@secondFactorMethod\",\"@secondFactorToken\",\"@backupEnabled\",\"@isLogin\"],[[30,7],[30,8],[30,9],true]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,10],[[[1,\"      \"],[8,[39,11],null,[[\"@allowedCredentialIds\",\"@challenge\",\"@showSecurityKey\",\"@showSecondFactor\",\"@secondFactorMethod\",\"@otherMethodAllowed\",\"@action\"],[[30,11],[30,12],[30,10],[30,3],[30,7],[30,13],[30,0,[\"authenticateSecurityKey\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,12],[[16,2,[30,8]],[24,1,\"login-second-factor\"],[4,[38,4],[\"keydown\",[30,0,[\"loginOnEnter\"]]],null],[4,[38,4],[\"input\",[28,[37,13],[[28,[37,14],[[28,[37,15],[[30,8]],null]],null]],null]],null]],[[\"@secondFactorMethod\"],[[30,7]]],null],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]],[1,\"\\n\"],[13]],[\"@loginName\",\"@canUsePasskeys\",\"@showSecondFactor\",\"@loginNameChanged\",\"@canLoginLocalWithEmail\",\"@loginPassword\",\"@secondFactorMethod\",\"@secondFactorToken\",\"@backupEnabled\",\"@showSecurityKey\",\"@securityKeyAllowedCredentialIds\",\"@securityKeyChallenge\",\"@otherMethodAllowed\"],false,[\"did-insert\",\"input\",\"value-entered\",\"if\",\"on\",\"i18n\",\"password-field\",\"toggle-password-mask\",\"unless\",\"d-icon\",\"second-factor-form\",\"security-key-form\",\"second-factor-input\",\"with-event-value\",\"fn\",\"mut\"]]",
  "moduleName": "discourse/components/modal/login/local-login-form.hbs",
  "isStrictMode": false
});